// 规则
var ruleTrigger = {
  'el-input': 'blur',
  'el-input-number': 'blur',
  'el-select': 'change',
  'el-radio-group': 'change',
  'el-checkbox-group': 'change',
  'el-cascader': 'change',
  'el-time-picker': 'change',
  'el-date-picker': 'change',
  'el-rate': 'change',
  'el-color-picker': 'change',
  'Weforsys-Quill': 'blur',
  "Weforsys-Text": 'blur',
  "Weforsys-Amount": 'change',
  "Weforsys-UploadFz": 'change',
  "Weforsys-UploadImg": 'change',
  "com-select": 'change',
  "dep-select": 'change',
  "pos-select": 'change',
  "user-select": 'change',
  "dic-select": 'change',
  "Weforsys-Address": 'change'
};
// 动态options
var dyOptionsList = ['radio', 'checkbox', 'select', 'cascader', 'treeSelect'];
// 不添加vModel
var noVModelList = ['divider', 'WeforsysText', 'groupTitle', 'relationFormAttr', 'relationFlowAttr'];
// 不可以添加到子表组件
var noTableAllowList = ['textarea', 'WeforsysText', 'WeforsysAmount', 'divider', 'editor', 'uploadImg', 'uploadFz', 'radio', 'checkbox', 'relationFormAttr', 'relationFlow', 'relationFlowAttr', 'groupTitle', 'createUser', 'createTime', 'modifyUser', 'modifyTime', 'currOrganize', 'currDept', 'currPosition', 'rate', 'slider', 'PsdInput', 'colorPicker'];
// 不可以添加到列表展示
var noColumnShowList = ['PsdInput', 'colorPicker', 'rate', 'slider', 'divider', 'uploadImg', 'uploadFz', 'editor', 'WeforsysText', 'relationFormAttr', 'relationFlowAttr', 'groupTitle'];
// 不可以添加到搜索
var noSearchList = [].concat(noColumnShowList, ['switch', 'timeRange', 'dateRange', 'relationForm', 'relationFlow', 'popupSelect']);
// 搜索时控件为input
var useInputList = ['comInput', 'textarea', 'WeforsysText', 'billRule'];
// 搜索时控件为日期选择器
var useDateList = ['createTime', 'modifyTime'];
// 搜索时控件为下拉选择器
var useSelectList = ['radio', 'checkbox', 'select'];
// 在线开发-功能设计/流程设计独有组件
var webPeculiarList = [{
  __config__: {
    weforsysKey: 'relationForm',
    label: '关联表单',
    labelWidth: undefined,
    showLabel: true,
    tag: 'relationForm',
    tagIcon: 'icon-ym icon-ym-generator-menu',
    defaultValue: '',
    required: false,
    layout: 'colFormItem',
    span: 24,
    dragDisabled: false,
    regList: [],
    trigger: 'change'
  },
  on: {
    change: '({ data, formData, setFormData, setShowOrHide, setRequired, setDisabled, request, getFieldOptions, setFieldOptions }) => {\n    // 在此编写代码\n    \n}'
  },
  placeholder: '请选择',
  flowId: '',
  relationField: '',
  columnOptions: [],
  clearable: true,
  filterable: false,
  disabled: false
}, {
  __config__: {
    weforsysKey: 'relationFormAttr',
    label: '关联表单属性',
    labelWidth: undefined,
    showLabel: true,
    tag: 'relationFormAttr',
    tagIcon: 'icon-ym icon-ym-generator-nature',
    defaultValue: '',
    required: false,
    layout: 'colFormItem',
    span: 24,
    dragDisabled: false
  },
  showField: '',
  relationField: ''
}, {
  __config__: {
    weforsysKey: 'calculate',
    label: '计算公式',
    labelWidth: undefined,
    showLabel: true,
    required: false,
    tag: 'calculate',
    tagIcon: 'icon-ym icon-ym-generator-count',
    defaultValue: null,
    layout: 'colFormItem',
    span: 24,
    dragDisabled: false,
    noShow: false,
    regList: []
  },
  expression: []
}, {
  __config__: {
    weforsysKey: 'popupSelect',
    label: '弹窗选择',
    labelWidth: undefined,
    showLabel: true,
    required: false,
    tag: 'popupSelect',
    tagIcon: 'icon-ym icon-ym-generator-checkbox',
    defaultValue: '',
    layout: 'colFormItem',
    span: 24,
    dragDisabled: false,
    regList: []
  },
  on: {
    change: '({ data, formData, setFormData, setShowOrHide, setRequired, setDisabled, request, getFieldOptions, setFieldOptions }) => {\n    // 在此编写代码\n    \n}'
  },
  interfaceId: '',
  columnOptions: [],
  propsValue: 'id',
  disabled: false,
  clearable: true
}];
// 在线开发-流程设计独有组件
var flowPeculiarList = [{
  __config__: {
    weforsysKey: 'relationFlow',
    label: '关联流程表单',
    labelWidth: undefined,
    showLabel: true,
    tag: 'relationFlow',
    tagIcon: 'icon-ym icon-ym-generator-flow',
    defaultValue: '',
    required: false,
    layout: 'colFormItem',
    span: 24,
    dragDisabled: false,
    regList: [],
    trigger: 'change'
  },
  placeholder: '请选择',
  modelId: '',
  relationField: '',
  clearable: true,
  filterable: false,
  disabled: false
}, {
  __config__: {
    weforsysKey: 'relationFlowAttr',
    label: '关联流程属性',
    labelWidth: undefined,
    showLabel: true,
    tag: 'relationFlowAttr',
    tagIcon: 'icon-ym icon-ym-generator-nature',
    defaultValue: '',
    required: false,
    layout: 'colFormItem',
    span: 24,
    dragDisabled: false
  },
  showField: '',
  relationField: ''
}];
export { ruleTrigger, dyOptionsList, noVModelList, noTableAllowList, noColumnShowList, noSearchList, webPeculiarList, flowPeculiarList, useInputList, useDateList, useSelectList };